import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createService } from "../../helpers/http_services_requests";
import { reaisToCents } from "../../utils/functions";

export default function ServiceNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Dados de Serviço",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "price",
                    label: "Preço",
                    type: "text",
                    mask: "currency",
                    required: true
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createService({ ...data, price: reaisToCents(data.price) }, () => navigate('/servicos'))
    };

    return <DynamicFormPage title={"Serviços - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
